<template>
  <div class="rights-exchange-list">
    <div v-for="option in content.rightsExchange" :key="option.name" class="exchange-option">
      <p>権利交換</p>
      <h2 class="option-name">{{ option.name }}</h2>
      <p>{{ option.title }}</p>
      <p class="option-description">{{ option.description }}</p>
    </div>
  </div>
</template>

<script>
import text from "@/assets/txt/free_stay.json";

let textDate = text;
export default {
  props: {},
  data() {
    return {
      content: textDate,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/molecules/freeStay/hotelrigthsexchange.scss";
</style>
